import { render, staticRenderFns } from "./BenefitNotificationBoxBase.vue?vue&type=template&id=751e75c1&scoped=true"
import script from "./BenefitNotificationBoxBase.vue?vue&type=script&lang=js"
export * from "./BenefitNotificationBoxBase.vue?vue&type=script&lang=js"
import style0 from "./BenefitNotificationBoxBase.vue?vue&type=style&index=0&id=751e75c1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751e75c1",
  null
  
)

export default component.exports